import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import Body from './common/Body';
import Info from './common/Info';

import heroStore from '../stores/hero';
import appStore from '../stores/app';

import { PADDING } from './styleConstants';
import { IS_WEB } from '../lib/appConstants';

import { inCombat } from '../utils/warriorUtils';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  infoWrapper: { marginLeft: PADDING },
});

// TODO: I dont know why we need here timeout problem is login string mounts twice
function forwardToCombat() {
  appStore.toggleLoading(true);
  appStore.navigate('Combat', 'outer');
}

export default class HeroScreen extends Component<{ navigation: any }> {
  componentDidMount() {
    if (inCombat(heroStore.hero)) {
      if (IS_WEB) forwardToCombat();
      else setTimeout(forwardToCombat, 0);
    }
  }

  render() {
    const { navigation } = this.props;

    return (
      <View testID="heroScreen" style={styles.container}>
        {IS_WEB && <View testID="hero.heroId" data-id={heroStore.hero.id} />}
        <View>
          <Body
            navigation={navigation}
            warrior={heroStore.hero}
            applyEnabled
            {...({ showThingInfo: true } as any)}
          />
        </View>
        <View style={styles.infoWrapper}>
          <Info />
        </View>
      </View>
    );
  }
}
